import { createClient } from '@supabase/supabase-js';

// Get credentials from environment variables
const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

// Security: Only log in development, never expose actual values
if (import.meta.env.DEV) {
  console.log('🔍 Supabase config: Initialized');
}

// Check if we have valid credentials
const hasValidCredentials = supabaseUrl && supabaseAnonKey && 
  supabaseUrl.trim() !== '' && 
  supabaseAnonKey.trim() !== '' &&
  supabaseUrl !== 'your_supabase_url_here' && 
  supabaseAnonKey !== 'your_supabase_anon_key_here';

if (!hasValidCredentials) {
  if (import.meta.env.DEV) {
    console.error('❌ Missing Supabase credentials. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY environment variables.');
  }
  throw new Error('Configuration error. Please contact support.');
}

// Security: Never log actual credentials, only confirm initialization
if (import.meta.env.DEV) {
  console.log('✅ Supabase client initialized');
}

// Create Supabase client with validated credentials
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'deepsearch'
  },
  auth: {
    redirectTo: `${window.location.origin}/email-confirmation`,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});

// Expose Supabase client globally so we can debug from browser console
if (typeof window !== 'undefined') {
  window.supabaseClient = supabase;
}

// Security: Remove debug logging in production
// Only log in development mode
if (import.meta.env.DEV) {
  const originalFrom = supabase.from;
  supabase.from = function(table) {
    console.log(`🔍 Supabase query to table: ${table}`);
    return originalFrom.call(this, table);
  };
}

/**
 * Helper to access deepsearch schema tables
 * Usage: supabase.deepsearch('items') instead of supabase.from('deepsearch.items')
 * PostgREST will automatically use the deepsearch schema since it's in search_path
 */
supabase.deepsearch = function(table) {
  // Use schema.table notation for PostgREST
  return this.from(`${table}`, { schema: 'deepsearch' });
};

export default supabase;